import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { CancelButtonStyled } from "./CancelButton.style";
import { CancelButtonType } from "./CancelButton.types";

const CancelButton: FC<CancelButtonType> = (props) => {
  const { t } = useTranslation();
  const {
    disabled,
    onClick,
    type,
    value = t("COMMON.CANCEL"),
    className,
  } = props;
  return (
    <CancelButtonStyled
      className={className}
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {value}
    </CancelButtonStyled>
  );
};

export default CancelButton;
